import { styled } from '@mui/material';

type Props = {
  isSelected: boolean;
  hexColor: string;
};

const ColorButton = styled('button')<Props>`
  width: 40px;
  height: 40px;
  border-radius: 50%;

  border: ${({ isSelected }) => (isSelected ? '3px solid black' : '1px solid #ccc')};
  background: ${({ hexColor }) => `#${hexColor}`};

  cursor: pointer;
`;

export default ColorButton;
